import { Injectable } from '@angular/core';
import { HttpClient,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs';
import { IPagedResults } from '../../../services/mocks/mock.interfaces';
import { User } from '../../../models/user.model';
import { LoggerService } from '../../../shared/services/logger.service';
import { environment } from '../../../../environments/environment';
import { ChartMockService } from 'src/app/services/mocks/chart.mocks';

@Injectable({
  providedIn: 'root'
})
export class AboutService {

  pieChartDetail: any;
  doughnutChartDetail: any;
  barChartDetail: any;
  lineChartDetail: any;
  radarChartDetail: any;

  constructor(private http: HttpClient,
              private logger: LoggerService, private chartMockService: ChartMockService,) {
  }

  getUserProfile(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/profile/username');
  }
  saveUserData(user: User): Observable<any> {  
    return this.http.post<any>(environment.apiBase+'/userdata/staff/save',user);
  }
  getUserData(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/userdata');
  }
  getDashboardData(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/admin/dashboard');
  }


  /*================MOCK Servces==================================*/
getPieChartLabelNDataMock(wsId: number): Observable<any> { 
  //return this.http.get<any>(environment.apiBase+'/report/processRunData?wsId='+wsId);
  this.chartMockService.getPieChartLabelNDataMock()
      .subscribe((response: IPagedResults<any>) => {
        //console.log(">>>Workspace.list.. "+JSON.stringify(response));
        this.pieChartDetail = response.results;
      },
      (err: any) => this.logger.log(err),
      () => this.logger.log('log here...'));
    return of(this.pieChartDetail);
}

getDoughnutChartLabelNDataMock(wsId: number): Observable<any> { 
  //return this.http.get<any>(environment.apiBase+'/report/processRunData?wsId='+wsId);
  this.chartMockService.getDoughnutChartLabelNDataMock()
      .subscribe((response: IPagedResults<any>) => {
        //console.log(">>>Workspace.list.. "+JSON.stringify(response));
        this.doughnutChartDetail = response.results;
      },
      (err: any) => this.logger.log(err),
      () => this.logger.log('log here...'));
    return of(this.doughnutChartDetail);
}
getBarChartLabelNDataMock(wsId: number): Observable<any> { 
  //return this.http.get<any>(environment.apiBase+'/report/processRunData?wsId='+wsId);
  this.chartMockService.getBarChartLabelNDataMock()
      .subscribe((response: IPagedResults<any>) => {
        //console.log(">>>Workspace.list.. "+JSON.stringify(response));
        this.barChartDetail = response.results;
      },
      (err: any) => this.logger.log(err),
      () => this.logger.log('log here...'));
    return of(this.barChartDetail);
}
getLineChartLabelNDataMock(wsId: number): Observable<any> { 
  //return this.http.get<any>(environment.apiBase+'/report/processRunData?wsId='+wsId);
  this.chartMockService.getLineChartLabelNDataMock()
      .subscribe((response: IPagedResults<any>) => {
        //console.log(">>>Workspace.list.. "+JSON.stringify(response));
        this.lineChartDetail = response.results;
      },
      (err: any) => this.logger.log(err),
      () => this.logger.log('log here...'));
    return of(this.lineChartDetail);
}
getRadarChartLabelNDataMock(wsId: number): Observable<any> { 
  //return this.http.get<any>(environment.apiBase+'/report/processRunData?wsId='+wsId);
  this.chartMockService.getRadarChartLabelNDataMock()
      .subscribe((response: IPagedResults<any>) => {
        //console.log(">>>Workspace.list.. "+JSON.stringify(response));
        this.radarChartDetail = response.results;
      },
      (err: any) => this.logger.log(err),
      () => this.logger.log('log here...'));
    return of(this.radarChartDetail);
}
}
